import React from 'react';
import {
  BodyText,
  HeadingText,
  v2magenta100,
  v2magenta500,
  v2neutral100,
} from '@paypalcorp/pp-react';

import styles from './charityLogo.less';

export default class extends React.Component {
  render() {
    const logoUrl =
      this.props.logo_url ||
      `https://${this.props.cdnHost}/paypal-ui/icons/svg/v2-causes.svg`;
    return (
      <div
        className={`npo-logo-container ${
          this.props.campaign ? `${styles['campaign-margin']}` : ''
        }`}
        style={{
          marginBottom: '24px',
        }}
      >
        <div
          className={'npo-avatar-container'}
          style={{
            backgroundColor: this.props.logo_url ? 'white' : v2magenta100,
            marginLeft: '24px',
            borderColor: v2neutral100,
            borderBottomStyle: 'solid',
          }}
        >
          <div
            className={'npo-avatar'}
            style={{
              background: `url(${logoUrl}) no-repeat center, center`,
              backgroundSize: 'contain',
              filter: this.props.logo_url
                ? ''
                : 'invert(22%) sepia(56%) saturate(2622%) hue-rotate(295deg) brightness(87%) contrast(91%)',
              maskSize: 'cover',
            }}
          />
        </div>
      </div>
    );
  }
}
